import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ICall} from '../../components/notetaker-card/notetaker-result/ICallInterface';
import {IBowlingAlleyService} from '../bowling-alley.service';

@Injectable({providedIn: 'root'})
export class BullhornBowlingAlleyService implements IBowlingAlleyService {
  private _cacheKey: string | undefined;
  private static NOVO_TARGET_ORIGIN = 'https://app.bullhornstaffing.com';

  launch(call: ICall, params: URLSearchParams) {
    this.initialise();
    this.open(call, params);
  }

  openEntity(entityType: string, entityId: string): void {
    this.initialise();
    this.openBullhornEntity(entityType, entityId);
  }

  private initialise(): void {
    if (this._cacheKey)
      return;

    this._cacheKey = Date.now().toString();
    const registerMessage = {action: 'register', message: {}, cacheKey: this._cacheKey, uuid: window.name};
    window.parent.postMessage(registerMessage, BullhornBowlingAlleyService.NOVO_TARGET_ORIGIN);
  }

  private open(call: ICall, params: URLSearchParams): void {
    const message: any = {
      action: 'open',
      cacheKey:
      this._cacheKey,
      uuid: window.name,
      message: {
        type: 'CustomAction',
        pageTitle: `Kyloe NoteTaker`,
        location: `${environment.uiHost}/notetaker?callId=${call.callId}&${params.toString()}`,
      }
    };
    window.parent.postMessage(message, BullhornBowlingAlleyService.NOVO_TARGET_ORIGIN);
  }

  private openBullhornEntity(entityType: string, entityId: string): void {
    const message: any = {
      action: 'open',
      cacheKey: this._cacheKey,
      uuid: window.name,
      message: {
        type: 'CustomAction',
        pageTitle: `${entityType} ${entityId}`,
        location: `https://bullhornstaffing.com/BullhornStaffing/OpenWindow.cfm?entity=${entityType}&id=${entityId}&view=Overview`
      }
    };
    window.parent.postMessage(message, BullhornBowlingAlleyService.NOVO_TARGET_ORIGIN);
  }
}
